module.exports = [
  {
    id: 'ca54afc0-ce18-40e5-9da0-a6588c56ff34',
    productType: 'EMS'
  },
  {
    id: '72b4eeea-14e1-4529-8c76-bf37cbdd555c',
    productType: 'NURSING'
  },
  {
    id: '72542c87-7d2e-4e2c-aee9-2e67296a75f8',
    productType: 'MILITARY'
  }
]